export const formatDateTime = (date: Date | string, time: string): string => {
  if (!date || !time) return '';
  
  let formattedDate: string;
  
  if (date instanceof Date) {
    formattedDate = date.toLocaleDateString('pl-PL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } else {
    // Якщо date є рядком, спробуємо його розпарсити
    try {
      const dateObj = new Date(date);
      formattedDate = dateObj.toLocaleDateString('pl-PL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      formattedDate = date;
    }
  }
  
  // Форматуємо час (детерміновано у 24h "HH:mm")
  let formattedTime = time;
  try {
    if (typeof time === 'string') {
      if (time.includes('T')) {
        const t = time.split('T')[1];
        formattedTime = t.slice(0, 5);
      } else {
        // Якщо це вже схоже на HH:mm, залишаємо, інакше пробуємо через Date
        const hhmmMatch = time.match(/^\d{1,2}:\d{2}$/);
        if (hhmmMatch) {
          const [h, m] = time.split(':');
          formattedTime = `${String(parseInt(h, 10)).padStart(2, '0')}:${m}`;
        } else {
          const d = new Date(time);
          const h = String(d.getHours()).padStart(2, '0');
          const m = String(d.getMinutes()).padStart(2, '0');
          formattedTime = `${h}:${m}`;
        }
      }
    }
  } catch {
    // fallback — залишаємо як є
    formattedTime = time;
  }
  
  return `${formattedDate}, ${formattedTime}`;
}; 